import React from "react";
import AdminSidebar from "../AdminSidebar/AdminSidebar"
import AdminHeader from "../AdminHeader/AdminHeader"
import { Outlet } from "react-router-dom";

const AdminDashboardLayout = () => {
  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <AdminSidebar />

      {/* Main Section */}
      <div className="flex-1 flex flex-col">
        {/* Header */}
        <AdminHeader />

        {/* Main content area */}
        <main className="flex-1 overflow-y-auto px-6 pb-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminDashboardLayout;
